import { ConditionalDisplay } from '@rsos/base-components';
import { useBooleanFlagValue } from '@rsos/feature-flags';
import { useSelectedAlert } from '@rsos/reduxDataStore/src/features/selectors/alertsSelectors';
import EventShareCard from '../JurisdictionView/EventPane/EventShareCard/EventShareCard';
import { buildShareUri } from '../ShareEvent/components/FieldShare/helpers';
import { ALERT_RESOURCE } from '../ShareEvent/constants/ShareEvent.types';

/**
 * Existing Field Shares for the selected alert.
 *
 * Thin wrapper over the shared share-list card — the list endpoint filters by
 * `uri`, so the same component serves calls (`tel://`) and alerts (`alert://`).
 *
 * `EventShareCard` already self-gates on the global Field Share pair
 * (`unite_sharing` + `field_sharing_0`), which is what suppresses this card on
 * calls. `alert-field-sharing` sits one level below that and gates alerts only,
 * so turning it off hides the whole alert-share surface rather than just the
 * Share button. Gating here rather than inside `EventShareCard` also means the
 * child never mounts, so the shares request is skipped — matching how the
 * global flag skips it for calls.
 */
const AlertShareCard = () => {
  const alertFieldSharingFlag = useBooleanFlagValue(
    'alert-field-sharing',
    false,
  );
  const selectedAlert = useSelectedAlert() as { alert_id?: string };
  const alertId = selectedAlert?.alert_id;

  return (
    <ConditionalDisplay
      dataName="alert-field-share-card"
      conditions={[
        {
          showIf: Boolean(alertFieldSharingFlag),
          reason:
            'Needs the alert-field-sharing feature flag (Field Share for alerts)',
        },
      ]}
    >
      <EventShareCard
        uri={buildShareUri(ALERT_RESOURCE, { alertId })}
        title="Alert Shared with Field Responders"
      />
    </ConditionalDisplay>
  );
};

export default AlertShareCard;
